import _ from 'lodash';
import React from 'react';

import {TenantBox} from './components';

import removeIcon from './assets/remove.svg';
import addSecondaryTenantIcon from './assets/add-secondary-tenant.svg';
import addGuarantor from './assets/add-guarantor.svg';

import './styles.css';

const AddSecondaryTenantBox = ({onClick}) => (
  <div className="addUserBox colab-centered colab-clickable" onClick={onClick}>
    <div className="addUserIconWrapper colab-centered-h">
      <img src={addSecondaryTenantIcon} alt="Add Secondary Tenant Icon" />
    </div>
    <div className="addUserText">Add a Secondary Member</div>
  </div>
);

const AddGuarantorBox = ({onClick}) => (
  <div className="addUserBox colab-centered colab-clickable" onClick={onClick}>
    <div className="addUserIconWrapper colab-centered-h">
      <img src={addGuarantor} alt="Add Guarantor Icon" />
    </div>
    <div className="addUserText">Add a Guarantor</div>
  </div>
);

const TenantInformation = ({
  locationRef,
  tenants,
  guarantor,
  roomTypeCapacity,
  openAgreementUserInfoModal,
  openAddGuarantorModal,
  openAddSecondaryTenantModal,
  openRemoveSecondaryTenantModal,
  openRemoveGuarantorModal
}) => {
  const [[primaryTenant], [secondaryTenant]] = _.partition(
    tenants,
    tenant => tenant.isPrimary
  );

  return (
    <div className="TenantInformation">
      <div className="boxesContainer">
        {primaryTenant && (
          <div className="boxWrapper">
            <TenantBox
              tenant={primaryTenant}
              locationRef={locationRef}
              onClick={() =>
                openAgreementUserInfoModal(primaryTenant.agreementUserId)
              }
            />
          </div>
        )}
        {secondaryTenant && (
          <div className="boxWrapper">
            <div
              className="removeIcon colab-centered colab-clickable"
              onClick={openRemoveSecondaryTenantModal}>
              <img src={removeIcon} alt="Remove Secondary Tenant Icon" />
            </div>
            <TenantBox
              tenant={secondaryTenant}
              locationRef={locationRef}
              onClick={() =>
                openAgreementUserInfoModal(secondaryTenant.agreementUserId)
              }
            />
          </div>
        )}
        {!secondaryTenant &&
          roomTypeCapacity > 1 && (
            <AddSecondaryTenantBox onClick={openAddSecondaryTenantModal} />
          )}
        {guarantor && (
          <div className="boxWrapper">
            <div
              className="removeIcon colab-centered colab-clickable"
              onClick={openRemoveGuarantorModal}>
              <img src={removeIcon} alt="Remove Guarantor Icon" />
            </div>
            <TenantBox
              tenant={guarantor}
              locationRef={locationRef}
              onClick={() =>
                openAgreementUserInfoModal(guarantor.agreementUserId)
              }
            />
          </div>
        )}
        {!guarantor && <AddGuarantorBox onClick={openAddGuarantorModal} />}
      </div>
    </div>
  );
};

export default TenantInformation;
